// React
import { Fragment, useEffect, useState } from "react"

// Third-Party Library
import { useLocation, useParams } from "react-router-dom"

// Functions
import { dateConvert, validation } from "functions"

// Components
import { DataStatus } from "components"

// Assets
import "./assets/css/style.css"

// View Components
import { FormSection } from "./components"

// API
import { Api } from "./components/OrderReview/api"

// UUID
import uuid from "react-uuid"
import * as yup from "yup"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

const Category = ({ baseData, setting }) => {
  // States
  const [code, setCode] = useState([])
  const [renderUuid, toggleUuid] = useState(true)

  useEffect(() => {
    // Variables
    const dataUuid = localStorage.getItem('uuid')

    const isUuid = value => {
      const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
      return regex.test(value)
    }

    if (!(dataUuid && isUuid(dataUuid))) {
      localStorage.setItem('uuid', uuid())
      toggleUuid(false)
    } else {
      Api.getPromo({
        unique_id: dataUuid
      }).then(res => {
        setCode(res.promo)
      }).finally(() => {
        toggleUuid(false)
      })
    }
  }, [])

  const ViewSection = ({ baseData, code, setting }) => {
    // Hooks
    const location = useLocation()
    const { value } = useParams()

    // Variables
    const category = baseData.category.filter(val => val.slug === value)
    const is_departure = Boolean(category ? category[0]?.is_departure ?? 0 : 0)
    const serviceToCart = location.state?.service ?? 0
    const today = new Date()

    // Form
    const isDeparture = () => {
      if (is_departure) {
        return {
          no_transportation: yup.boolean().label("Transportation Policy").required().oneOf(validation().mustAccept.value, validation().mustAccept.label)
        }
      }

      return null
    }
    const defaultValues = {
      code,
      booking_date: dateConvert(today).default.format,
      page: 1,
      _code: code,
      unique_id: localStorage.getItem("uuid") ?? uuid(),
      policy: false,
      terms: false,
      date_of_birth: "",
      email: "",
      email_confirmation: "",
      first_name: "",
      gender: "",
      last_name: "",
      nationality: 101,
      payment_method: "",
      phone: "",
      additional_cost: false,
      no_transportation: false,
      waiver: false,
      qty_insurance: 0,
      ticket: serviceToCart ? [{
        ...serviceToCart,
        service_name: serviceToCart.name,
        name: category[0].name,
        image: serviceToCart?.category?.image,
        choosed_service: serviceToCart.id,
        pax: 1,
        price: parseFloat(serviceToCart.price),
      }] : []
    }
    const validationSchema = yup.object().shape({
      payment_method: yup.string().required("Select Payment Method"),
      terms: yup.boolean().label("Terms and Conditions").required().oneOf(validation().mustAccept.value, validation().mustAccept.label),
      policy: yup.boolean().label("Policy").required().oneOf(validation().mustAccept.value, validation().mustAccept.label),
      first_name: yup.string().label("First Name").required(),
      last_name: yup.string().label("Last Name").required(),
      phone: yup.number().label("Phone").typeError(validation().number.label).required(),
      nationality: yup.string().label("Nationality").required(),
      email: yup.string().label("Email").email(validation().email.label).required(),
      email_confirmation: yup.string().label("Email Confirmation").oneOf([yup.ref("email")], validation(["Email Confirmation", "Email"]).exact.label).required(),
      date_of_birth: yup.date().label("Date of Birth").required(),
      gender: yup.string().label("Gender").required(),
      waiver: yup.boolean().label("Splash Waiver").required().oneOf(validation().mustAccept.value, validation().mustAccept.label),
      ...isDeparture()
    })
    const methods = useForm({
      defaultValues,
      resolver: yupResolver(validationSchema)
    })

    const Section = ({ children, ...rest }) => (
      <section className="my-3 container" {...rest}>
        {children}
      </section>
    )

    return (
      <Fragment>
        <Section>
          <h2 className="fw-bold text-center">Make A Day Pass Booking</h2>
        </Section>
  
        <section className="my-3">
          <FormProvider {...methods}>
            <FormSection baseData={baseData} category={category} setting={setting} />
          </FormProvider>
        </section>
      </Fragment>
    )
  }

  if (renderUuid) {
    return <DataStatus loading>Loading...</DataStatus>
  } else {
    return <ViewSection baseData={baseData} code={code} setting={setting} />
  }
}

export default Category